import { useNavigate } from 'react-router-dom';
import { analytics, logEvent } from '@/firebase';
import { Button, Icon, Typography } from '@ford/ford-ui-components';
import type { Bootcamp } from '@/types/bootcamp';
import { getBootcampState, formatEventDateRange } from '@/utils/bootcamp';
import styles from '@/pages/main/_index.module.css';

interface BootcampCardProps {
  bootcamp: Bootcamp;
}

const BootcampCard = ({ bootcamp }: BootcampCardProps) => {
  const navigate = useNavigate();
  const state = getBootcampState(bootcamp);
  const isRegistrationOpen = state === 'registration_open';

  const handleClick = () => {
    if (!isRegistrationOpen) return;

    logEvent(analytics, 'select_content', {
      content_type: 'signup_button',
      content_id: `signup_${bootcamp.slug}`,
      bootcamp_id: bootcamp.id,
      bootcamp_name: bootcamp.name,
      location: bootcamp.slug,
    });

    // Preserve any pre-selected module/bookeo ID
    const selectedModule = sessionStorage.getItem('selectedModule');
    const selectedBookeoId = sessionStorage.getItem('selectedBookeoId');
    let url = `/bootcamp/${bootcamp.slug}`;
    const params = new URLSearchParams();
    if (selectedModule) params.append('module', selectedModule);
    if (selectedBookeoId) params.append('bid', selectedBookeoId);
    if (params.toString()) url += `?${params.toString()}`;

    navigate(url);
    sessionStorage.removeItem('selectedModule');
    sessionStorage.removeItem('selectedBookeoId');
  };

  return (
    <div className={styles.signupCard}>
      <div className={styles.signupLocation}>
        <Typography displayStyle="title-medium" displayColor="text-onlight-strong">
          {bootcamp.name}
        </Typography>
      </div>
      <div className={styles.signupVenue}>
        <Typography displayStyle="body-1-regular" displayColor="text-onlight-subtle">
          {bootcamp.location.venue}
        </Typography>
      </div>
      <div className={styles.signupDates}>
        <Typography displayStyle="body-1-regular" displayColor="text-onlight-subtle">
          {formatEventDateRange(bootcamp.dates.eventStart, bootcamp.dates.eventEnd, bootcamp)}
        </Typography>
      </div>
      <Button
        variant="filled"
        rightIcon={<Icon name="chevronRight" />}
        disabled={!isRegistrationOpen}
        onClick={handleClick}
      >
        {bootcamp.card.ctaText}
      </Button>
    </div>
  );
};

export default BootcampCard;
